module.exports = __webpack_public_path__ + "img/bank_05.60b042be.png";